import { DateTime } from "luxon";

import { Filters } from "./interfaces";

export const getInitialFilters = (): Filters => ({
  type: [],
  severity: [],
  user: [],
  vehicle: [],
  videoOnly: true,
  date: [
    DateTime.now().setZone("utc").startOf("day").minus({ days: 30 }).toISO(),
    DateTime.now().setZone("utc").endOf("day").toISO(),
  ],
});
